import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
    const navigate = useNavigate();
    const home = () => {
        navigate("/")
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div>
            
            <div className="container px-3">
                <section className="faq-hero container p-4 p-lg-5 rounded-5 mt-5">
                    <h1>Terms & Conditions</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item cursorpointer">
                                <a href="#" onClick={(e) => { e.preventDefault(); home(); }} style={{ cursor: 'pointer' }}>
                                    Home
                                </a>
                            </li>
                            <li className="breadcrumb-item active">Terms & Conditions</li>
                        </ol>
                    </nav>
                </section>

                <div className="blog-wrapper mt-lg-5 pt-lg-5 mb-lg-5">
                    <main className="blogmargintop mb-5">
                        <div className="terms-conditions-content mt-2">
                            
                            <h3 className="term-heading">1. General Disclaimer</h3>
                            <p className="term-desc">
                                Asra Immigration provides immigration guidance, documentation support, and related services.
                            </p>
                            <ul className="terms-list">
                                <li>We do not guarantee visa approval, processing timelines, or decisions made by IRCC, USCIS, UKVI, or any immigration authority</li>
                                <li>All final decisions are made solely by the respective government bodies</li>
                            </ul>

                            <h3 className="term-heading mt-lg-5">2. Eligibility Assessment</h3>
                            <p className="term-desc">
                                Any eligibility assessment provided by Asra Immigration is based on the information you share.
                            </p>
                            <p className="term-desc">
                                You are responsible for:
                            </p>
                            <ul className="terms-list">
                                <li>Providing true and accurate information</li>
                                <li>Submitting valid documents</li>
                                <li>Updating us if any information changes</li>
                            </ul>
                            <p className="term-desc">
                                Asra Immigration is not responsible for delays or refusals resulting from inaccurate or incomplete information.
                            </p>

                            <h3 className="term-heading mt-lg-5">3. Service Fees</h3>
                            <ul className="terms-list">
                                <li>All service fees are non-refundable, unless otherwise mentioned in writing</li>
                                <li>Government fees (IRCC, ECA, WES, IELTS, etc.) are not included in our service charges</li>
                                <li>Payments must be completed before initiating any service</li>
                            </ul>

                            <h3 className="term-heading mt-lg-5">4. Processing Time</h3>
                            <p className="term-desc">
                                Immigration processing times depend entirely on the respective immigration authorities.
                            </p>
                            <p className="term-desc">
                                Asra Immigration cannot control:
                            </p>
                            <ul className="terms-list">
                                <li>Delays</li>
                                <li>Requests for additional documents</li>
                                <li>Background checks</li>
                                <li>Interview requirements</li>
                            </ul>
                            <p className="term-desc">
                                Processing timelines are approximate only, not guaranteed.
                            </p>

                            <h3 className="term-heading mt-lg-5">5. No Job Guarantee</h3>
                            <p className="term-desc">
                                Asra Immigration does not:
                            </p>
                            <ul className="terms-list">
                                <li>Offer guaranteed jobs</li>
                                <li>Provide employment promises</li>
                                <li>Arrange jobs for immigration purposes</li>
                            </ul>
                            <p className="term-desc">
                                Any job information shared is only for guidance.
                            </p>

                            <h3 className="term-heading mt-lg-5">6. Document Handling</h3>
                            <p className="term-desc">
                                We maintain confidentiality of your documents.
                            </p>
                            <p className="term-desc">
                                However, you are responsible for:
                            </p>
                            <ul className="terms-list">
                                <li>Providing clear, valid, and complete documents</li>
                                <li>Submitting originals when required</li>
                            </ul>
                            <p className="term-desc">
                                We are not responsible for results caused by incorrect documents.
                            </p>

                            <h3 className="term-heading mt-lg-5">7. Refund Policy</h3>
                            <p className="term-desc">
                                Refunds are not provided for:
                            </p>
                            <ul className="terms-list">
                                <li>Visa refusal</li>
                                <li>Change of mind</li>
                                <li>Delays in government processing</li>
                                <li>Incorrect information provided by the client</li>
                            </ul>
                            <p className="term-desc">
                                Refunds apply only if Asra Immigration fails to deliver the service explicitly agreed upon in a signed agreement.
                            </p>

                            <h3 className="term-heading mt-lg-5">8. Client Responsibilities</h3>
                            <p className="term-desc">
                                You agree to:
                            </p>
                            <ul className="terms-list">
                                <li>Provide timely and accurate information</li>
                                <li>Respond to emails/calls for document requirements</li>
                                <li>Review all forms before submission</li>
                                <li>Pay fees on time</li>
                            </ul>
                            <p className="term-desc">
                                Asra Immigration is not liable for outcomes resulting from your negligence.
                            </p>

                            <h3 className="term-heading mt-lg-5">9. Website Usage</h3>
                            <p className="term-desc">
                                By using our website, you agree not to:
                            </p>
                            <ul className="terms-list">
                                <li>Copy content</li>
                                <li>Misuse information</li>
                                <li>Perform unauthorized data extraction</li>
                            </ul>
                            <p className="term-desc">
                                All website content is the property of Asra Immigration.
                            </p>

                            <h3 className="term-heading mt-lg-5">10. Limitation of Liability</h3>
                            <p className="term-desc">
                                Asra Immigration is not responsible for:
                            </p>
                            <ul className="terms-list">
                                <li>Visa refusals</li>
                                <li>Financial loss</li>
                                <li>Emotional or indirect damages</li>
                                <li>Government policy changes</li>
                                <li>Delays caused by third parties</li>
                            </ul>
                            <p className="term-desc">
                                Our responsibility is limited to professional consultation and documentation assistance only.
                            </p>

                            <h3 className="term-heading mt-lg-5">11. Changes to Terms</h3>
                            <p className="term-desc">
                                Asra Immigration reserves the right to modify these Terms & Conditions at any time.
                                Continued use of our services means you accept the updated terms.
                            </p>

                            <h3 className="term-heading mt-lg-5">12. Contact Information</h3>
                            <ul className="terms-list contact-info">
                                <li><strong>Address:</strong> 323 Sweetclover Way, Ottawa, ON, K4A 1E6</li>
                                <li><strong>Phone:</strong> +1-613-209-9539</li>
                                <li><strong>Email:</strong> info@asraimmigration.ca</li>
                                <li><strong>Website:</strong> asraimmigration.ca</li>
                            </ul>

                        </div>
                    </main>
                </div>
            </div>
            
        </div>
    )
}

export default TermsAndConditions;